import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

/**
 * Aggiorna una sessione esistente invece di eliminarla e ricrearla
 * @param {string} uname - Username
 * @param {string} token - Token di autenticazione
 * @param {number} id_sessione - ID della sessione da aggiornare
 * @param {number} ordine - Ordine della sessione (1=mattina, 2=pomeriggio)
 * @param {string} ora_inizio - Ora inizio (HH:MM)
 * @param {string} ora_fine - Ora fine (HH:MM)
 * @param {array|string} id_insegnanti - ID insegnanti (array o stringa CSV)
 * @param {array|string} id_materia - ID materie (array o stringa CSV)
 * @param {array|string|null} id_aula - ID aule (array o stringa CSV o null)
 * @returns {Promise} Risposta dal backend
 */
export default async function updateSessioneLezione(
  uname,
  token,
  id_sessione,
  ordine,
  ora_inizio,
  ora_fine,
  id_insegnanti,
  id_materia,
  id_aula = null
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateSessioneLezione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        var bodyStr = body.toString();

        if (!bodyStr || bodyStr.trim() === "") {
          console.warn("[updateSessioneLezione] API backend non risponde");
          resolve({
            result: "KO",
            message: "Backend API non disponibile",
          });
          return;
        }

        try {
          const resp = JSON.parse(bodyStr);
          console.log("[updateSessioneLezione] Risposta backend:", resp);
          resolve(resp);
        } catch (error) {
          console.error(
            "[updateSessioneLezione] Errore parsing JSON:",
            error,
            "Body:",
            bodyStr
          );
          resolve({
            result: "KO",
            message: "Errore nel parsing della risposta",
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    // Converte array in stringa CSV se necessario
    const insegnantiStr = Array.isArray(id_insegnanti)
      ? id_insegnanti.join(",")
      : id_insegnanti;

    const materieStr = Array.isArray(id_materia)
      ? id_materia.join(",")
      : id_materia;

    const auleStr = Array.isArray(id_aula) ? id_aula.join(",") : id_aula;

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_sessione: id_sessione,
      ordine: ordine,
      ora_inizio: ora_inizio,
      ora_fine: ora_fine,
      id_insegnanti: insegnantiStr,
      id_materia: materieStr,
      id_aula: auleStr,
    });

    req.write(postData);
    req.end();
  });
}
